import react, { useEffect, useReducer } from 'react'
import {
    Box, Dialog, DialotActions, DialogContent, DialogTitle,
    DialogActions, Button, Alert, TextField, List, ListItem, InputLabel, IconButton,
    Tooltip, Chip, FormControl, Divider
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { lockedReducer } from '../../../utils/defaultReducer'
import api from '../../../api'
import Loading from '../../Loading'
import { getSession } from '../../../auth'
import useNotification from '../../Notification'
import ConfirmationDialog from '../../Dialogs/Confirmation'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add';
import ApprovalIcon from '@mui/icons-material/Approval';
import { FileDrop } from 'react-file-drop';
import LoadingButton from '@mui/lab/LoadingButton';
import ImportIcon from '@mui/icons-material/Upload';

const translations = {
    APPROVED: "Aprovado",
    AVAILABLE_WITHOUT_REVIEW: "Disponível sem revisão",
    DECLINED: 'Recusado',
    EXPIRED: 'Expirado',
    NON_EXISTS: 'Não existe',
    NONE: 'Nenhum',
    PENDING_REVIEW: 'Aguardando revisão'
}

const initializeName = async (id, setState) => {
    const enterpriseId = getSession()?.profile?.enterprise?.id
    setState({ loading: true, new_display_name: null, new_name_status: null })
    const res = await api.get(`api/enterprises/${enterpriseId}/whatsapp/exibition_name/${id}/`, { timeout: 27000 })
    const newstate = { loading: false }
    if (res.status === 200) {
        Object.assign(newstate, res.data)
        newstate.new_verified_name = res.data.verified_name

    } else {
        useNotification(
            'Ops!',
            'Ocorreu um erro para localizar os dados',
            'danger'
        )
    }
    setState(newstate)
}

const initializeEnterprise = async (id, setState) => {
    const enterpriseId = getSession()?.profile?.enterprise?.id
    setState({ loading: true })
    const res = await api.get(`api/enterprises/${enterpriseId}/whatsapp/enterprise_profile/${id}/`, { timeout: 27000 })
    const newstate = { loading: false }
    if (res.status === 200) {
        Object.assign(newstate, (res.data?.data || [{}]).pop())
    } else {
        useNotification(
            'Ops!',
            'Ocorreu um erro para localizar os dados',
            'danger'
        )
    }
    setState(newstate)
}

const changeExibitionName = async (state, setState) => {
    const enterpriseId = getSession()?.profile?.enterprise?.id
    setState({ loading: true })
    const res = await api.post(`api/enterprises/${enterpriseId}/whatsapp/exibition_name/${state.item_id}/`, state, { timeout: 27000 })
    const newstate = { loading: false, confirmation: null }
    if (res.status === 200) {
        useNotification(
            'Sucesso!',
            'Solicitação de troca de nome enviada com sucesso!',
            'success'
        )
        await initializeName(state.item_id, setState)
    }
    else {
        useNotification(
            'Ops!',
            'Ocorreu um erro para alterar o nome do número.',
            'danger'
        )
    }
    setState(newstate)
}

const updateExibitionName = async (state, setState) => {
    const enterpriseId = getSession()?.profile?.enterprise?.id
    setState({ loading: true })
    const res = await api.patch(`api/enterprises/${enterpriseId}/whatsapp/exibition_name/${state.item_id}/`, {}, { timeout: 27000 })
    const newstate = { loading: false, confirmation: null }
    if (res.status === 200) {
        useNotification(
            'Sucesso!',
            'Alteração efetuada com sucesso!',
            'success'
        )
        newstate.new_display_name = null
        newstate.new_name_status = null
        await initializeName(state.item_id, setState)
    }
    else {
        useNotification(
            'Ops!',
            'Ocorreu um erro para registrar o nome do número.',
            'danger'
        )
    }
    setState(newstate)
}

const uploadFile = async (file, item_id, setState) => {
    const enterpriseId = getSession()?.profile?.enterprise?.id
    setState({ loading: true })
    const formdata = new FormData()
    formdata.append('file', file)
    const res = await api.post(`api/enterprises/${enterpriseId}/whatsapp/upload/${item_id}/`, formdata, { timeout: 27000 })
    if (res.status === 200) {
        useNotification(
            'Sucesso!',
            'Imagem carregada com sucesso',
            'success'
        )
        return res.data.h
    } else {
        useNotification(
            'Ops!',
            'O carregamento da imagem falhou!',
            'danger'
        )
    }
    setState({ loading: false })
}

const changeEnterpriseProfile = async (state, setState) => {
    const enterpriseId = getSession()?.profile?.enterprise?.id

    const payload = state
    if (state.uploaded_file) {
        const file_handler = await uploadFile(state.uploaded_file, state.item_id, setState)
        if (!file_handler) return
        payload.profile_picture_handle = file_handler
    }

    setState({ loading: true })

    const res = await api.post(`api/enterprises/${enterpriseId}/whatsapp/enterprise_profile/${state.item_id}/`, state, { timeout: 27000 })
    const newstate = { loading: false, confirmation: null }
    if (res.status === 200) {
        useNotification(
            'Sucesso!',
            'Solicitação de atualização de perfil enviada com sucesso!',
            'success'
        )
        await initializeEnterprise(state.item_id, setState)
    }
    else {
        useNotification(
            'Ops!',
            'Ocorreu um erro para alterar p perfil número.',
            'danger'
        )
    }
    setState(newstate)
}

export const ExibitionNameModal = ({ data, handleClose }) => {

    const [state, setState] = useReducer(lockedReducer, {
        item_id: data.id,
        id: 0,
        new_verified_name: data?.info?.verified_name || "",
        new_display_name: null,
        new_name_status: null,
        confirmation: null,
        loading: false,
        ...data.info
    })

    useEffect(() => {
        initializeName(state.item_id, setState)
    }, [])

    return (
        <>
            <Loading loading={state.loading} />
            {state.confirmation &&
                <ConfirmationDialog
                    handleClose={() => setState({ confirmation: null })}
                    open={true}
                    title={'Confirmação'}
                    handleSubmit={() => state.confirmation()}
                    description={<>
                        <Alert severity='warning'>Confirma a troca do nome de exibição do número?</Alert>
                    </>}
                />}
            <Dialog
                open={true}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box>Nome de exibição</Box>
                    <Box>
                        <Button onClick={() => window.open("https://instant.getoutline.com/s/canal-do-cliente/doc/criando-eventos-na-agenda-e-automatizando-notificacoes-G0Rn78oIZL", "_blank")}>FAQ</Button>
                        <Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={() => handleClose(state)} ><CloseIcon /></Button>
                    </Box>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', padding: '.5rem 1rem' }}>
                        <Alert severity='warning'>O nome de exibição precisará ser aprovado pela META. <br></br>
                            O nome de exibição pode ser alterado até 10 vezes em 30 dias.</Alert>
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            Status do nome: <Box>{translations[state.name_status] || state.name_status}</Box>
                        </Box>

                        {state.new_display_name &&
                            <>
                                <Box sx={{ display: 'flex', gap: '1rem' }}>
                                    Nome solicitado para troca: <Box>{state.new_display_name}</Box>
                                </Box>
                                {(state.new_name_status === 'APPROVED') &&
                                    <Alert severity='info'>
                                        O nome foi aprovado. Clique no botão a seguir para registrá-lo novamente.
                                        <Tooltip title='Alterar nome'><IconButton onClick={() => updateExibitionName(state, setState)}><ApprovalIcon /></IconButton></Tooltip>
                                    </Alert>}
                                <Box sx={{ display: 'flex', gap: '1rem' }}>
                                    Status do nome solicitado para troca: <Box>{translations[state.new_name_status] || state.new_name_status}</Box>
                                </Box>
                            </>
                        }
                        <TextField
                            fullWidth
                            size='small'
                            label='Nome de exibição'
                            value={state.new_verified_name}
                            onChange={({ target }) => setState({ new_verified_name: target.value })}
                        />
                    </Box>
                </DialogContent>
                <DialogActions style={{ padding: "10px 20px 10px 10px" }}>
                    <Button
                        onClick={() => { initializeName(state.item_id, setState) }}>
                        Atualizar
                    </Button>
                    <Button
                        disabled={['PENDING_REVIEW', 'APPROVED'].includes(state.new_name_status) && state.new_display_name}
                        onClick={() => setState({ confirmation: () => changeExibitionName(state, setState) })}>
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export const EnterpriseDataModal = ({ data, handleClose }) => {

    const [state, setState] = useReducer(lockedReducer, {
        item_id: data.id,
        about: '',
        address: '',
        description: '',
        messaging_product: '',
        profile_picture_url: '',
        //vertical: '', // not implemented yet
        uploaded_file: null,
        websites: [],
        confirmation: null,
        loading: false,
    })

    useEffect(() => {
        initializeEnterprise(state.item_id, setState)
    }, [])

    return (
        <>
            <Loading loading={state.loading} />
            {state.confirmation &&
                <ConfirmationDialog
                    handleClose={() => setState({ confirmation: null })}
                    open={true}
                    title={'Confirmação'}
                    handleSubmit={() => state.confirmation()}
                    description={<>
                        <Alert severity='warning'>Confirma as alterações?</Alert>
                    </>}
                />}
            <Dialog
                open={true}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box>Perfil da empresa</Box>
                    <Box>
                        <Button onClick={() => window.open("https://instant.getoutline.com/s/canal-do-cliente/doc/criando-eventos-na-agenda-e-automatizando-notificacoes-G0Rn78oIZL", "_blank")}>FAQ</Button>
                        <Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={handleClose} ><CloseIcon /></Button>
                    </Box>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', padding: '.5rem 1rem' }}>
                        <TextField
                            fullWidth
                            size='small'
                            label='Sobre'
                            value={state.about}
                            onChange={({ target }) => setState({ about: target.value })}
                        />
                        <TextField
                            fullWidth
                            size='small'
                            label='Endereço'
                            value={state.address}
                            onChange={({ target }) => setState({ address: target.value })}
                        />
                        <TextField
                            fullWidth
                            size='small'
                            label='Descrição'
                            value={state.description}
                            onChange={({ target }) => setState({ description: target.value })}
                        />
                        
                        <FormControl fullWidth size="small" sx={{position: 'relative'}}>
                            <InputLabel className='profile-input-label-positioner' >Foto de perfil</InputLabel>
                            <div className="file-drop-container small">
                                <FileDrop
                                    onDrop={(files, event) => setState({ uploaded_file: files[0] })}
                                >

                                    {(state.uploaded_file || state.profile_picture_url) ?
                                        <Box sx={{position: 'relative'}}>
                                            {state.uploaded_file &&
                                                <IconButton
                                                    className={'action-button delete'}
                                                    sx={{position: 'absolute', top: 0, right: 0}}
                                                    onClick={() => { setState({ uploaded_file: null }) }}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            }
                                            <img
                                                src={(state.uploaded_file ? URL.createObjectURL(state.uploaded_file) : state.profile_picture_url)}
                                                style={{ maxWidth: "100%", marginBottom: ".5rem", height: '12rem', width: '12rem', borderRadius: '50%', objectFit: 'cover' }} />
                                        </Box>
                                        : (
                                            <span>Arraste e solte para inserir a mídia dentre os formatos:  jpeg, jpg, png.</span>
                                        )}
                                    <span>ou</span>
                                    <LoadingButton
                                        variant="contained"
                                        color="primary"
                                        component="label"
                                        loading={false}
                                        loadingPosition="start"
                                        startIcon={<ImportIcon />}
                                        disabled={false}
                                        onClick={() => { }}
                                    >
                                        Selecione a imagem
                                        <input
                                            hidden
                                            accept={'image/jpeg, image/jpg, image/png'}
                                            type="file"
                                            onChange={(e) => setState({ uploaded_file: e.target.files[0] })}
                                        />
                                    </LoadingButton>
                                </FileDrop>
                            </div>
                        </FormControl>



                        <List>
                            <InputLabel>Websites</InputLabel>{state.websites.map((website, index) => (
                                <ListItem>
                                    <TextField
                                        fullWidth
                                        size='small'
                                        value={website}
                                        onChange={({ target }) => {
                                            state.websites[index] = target.value
                                            setState({ websites: [...state.websites] })
                                        }}
                                    />
                                    <IconButton onClick={() => setState({ websites: state.websites.filter((_, i) => i !== index) })}><DeleteIcon /></IconButton>
                                </ListItem>
                            ))}
                            {(state.websites || []).length < 3 && <IconButton onClick={() => setState({ websites: [...state.websites, ''] })}><AddIcon /></IconButton>}

                        </List>

                    </Box>
                </DialogContent>
                <DialogActions style={{ padding: "10px 20px 10px 10px" }}>
                    <Button onClick={() => setState({ confirmation: () => changeEnterpriseProfile(state, setState) })}>
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export const EnterpriseMoreModal = ({data, handleClose}) => {

    const [state, setState] = useReducer(lockedReducer, {
        item_id: data.id,
        id: 0,
        new_verified_name: data?.info?.verified_name || "",
        new_display_name: null,
        new_name_status: null,
        confirmation: null,
        loading: false,
        ...data.info
    })

    useEffect(() => {
        initializeName(state.item_id, setState)
    }, [])

    return (
            <Dialog
                open={true}
                fullWidth
                maxWidth="sm"
            >
                <Loading loading={state.loading} />
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box>Informações adicionais</Box>
                    <Box>
                        <Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={handleClose} ><CloseIcon /></Button>
                    </Box>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', padding: '.5rem 1rem' }}>
                       
                    </Box>
                </DialogContent>
            </Dialog>
    )
}